import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  return <div className={`relative group w-full ${className}`} data-id="element-1">
      {/* Pulsing Glow Background */}
      <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-xl blur opacity-60 group-hover:opacity-100 transition duration-500 animate-pulse" data-id="element-2"></div>

      {/* Actual Button */}
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick} className="relative w-full px-8 py-5 bg-gradient-to-b from-blue-500 to-blue-700 rounded-xl font-black text-xl md:text-2xl text-white uppercase tracking-wide shadow-xl border border-blue-400/30 flex items-center justify-center space-x-3" data-id="element-3">
        {children}
      </motion.button>
    </div>;
}